import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { Partner_Service_URL } from "../Url";

export const firmAccountVerficationActions = {
  ACCOUNT_DETAILS_VERIFICATION_SUCCESS: "ACCOUNT_DETAILS_VERIFICATION_SUCCESS",
  ACCOUNT_DETAILS_VERIFICATION_ERROR: "ACCOUNT_DETAILS_VERIFICATION_ERROR",
};

export function saveAccountNoDetails(props) {
  const { access_token, values, partnerFirmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/partnerBankAccountVerification?partnerFirmId=${partnerFirmId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveAccountDetailsVerifySuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveAccountDetailsVerifyError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveAccountDetailsVerifyError(err));
          return err.response;
        }
      });
}

export function saveAccountDetailsVerifyError(error) {
  return {
    type: firmAccountVerficationActions.ACCOUNT_DETAILS_VERIFICATION_ERROR,
    payload: error,
  };
}

export function saveAccountDetailsVerifySuccess(props) {
  return (dispatch) => {
    dispatch({
      type: firmAccountVerficationActions.ACCOUNT_DETAILS_VERIFICATION_SUCCESS,
      payload: props,
    });
  };
}
